export default "__VITE_ASSET__cc7A1Pd$__"